/**
 * The text transformations supported options
 */
const TEXT_TRANSFORM = {
    CAPITALIZE: 'capitalize',
    LOWERCASE: 'lowerCase',
    UPPERCASE: 'upperCase',
    SENTENCE_CASE: 'sentenceCase',
    NONE: 'none',
};

/**
 * The text words separator
 * @type {String}
 */
const WORDS_SEPARATOR = ' ';

export { TEXT_TRANSFORM, WORDS_SEPARATOR };
